/* eslint-disable no-unused-vars */
import axios from "axios";
import { getFunctions, httpsCallable } from "firebase/functions"
import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import newprairilogo from "../assets/newprairilogo.png";
import { updateLatestActions, generateRandomString, sendBugEmails } from "../utils.js";
import { loadStripe } from "@stripe/stripe-js";
import validator from "validator";
import CryingIcon from "../assets/unicorn-crying.png";
import { MdCheckCircle } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { countriesData } from "../countriesData.js";
import Cards from "../assets/credit-card-logos.png";
import GreenTick from "../assets/lightergreentick.png";
import {
  TextButton,
  Modal,
  PrairiButton,
  NotValid,
  Bullet,
  BugTab,
  Pricing,
  Loading
} from "@peterfosso/prairi-components";
import { useMediaQuery } from "react-responsive";
import ReCAPTCHA from "react-google-recaptcha";
import { CountryDropdown } from "react-country-region-selector";
import { storage } from "../firebase/firebaseApp";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import {
  collection,
  db,
  addDoc,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  Timestamp,
  updateDoc,
} from "../firebase/firebaseApp";
import { navBarContext } from "./context/context";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { formControlClasses } from "@mui/material";

import SilverDot from "../assets/silver-dot.png";

import { analytics } from "../firebase/firebaseApp";
import { logEvent } from "firebase/analytics";


//HOOKS Smaller
import RequestNoteInvestor from "./invitation/RequestNoteInvestor";
import NotSeekingStartup from "./invitation/NotSeekingStartup";
import SeekingStartup from "./invitation/SeekingStartup";
import { render } from "@testing-library/react";
import { getAuth, signInWithCustomToken, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";


const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "1px",
  },
}));
const Invitation = () => {
  const stripePromise = loadStripe(
    "pk_live_51P3Ify00vN5ANT6HieNrKMlp3npEccqmc0E85fOyxSGeI5PE5W2OLeiCXny2pGY8sRSCnG0vj22pMX1XFEoRs3Uu00y9nYHwha"
        //"pk_test_51P3Ify00vN5ANT6HucCsiG340LyhLpaEDOLkr9Mn4b5Yylrfjr5Kru5U4q687CUUwiPvJyEKfUKDHmskvvmaInIt00vlsennwu"
  );

  let { categoryName, promoId } = useParams();
  const { navBarHeight } = useContext(navBarContext);
  const [errorPopup, setErrorPopup] = useState(false);
  const [usedEmail, setUsedEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isStripe, setIsStripe] = useState(false);
  const [submitted, setSubmitted] = useState(false)
  const [docId, setDocId] = useState("");
  const [validPopup, setValidPopup] = useState(false);

  const [questionPopup, setQuestionPopup] = useState(false);
  const [promoCodes, setPromoCodes] = useState([]);
  const [acceptedCode, setAcceptedCode] = useState(false)
  const [wrongCode, setWrongCode] = useState(false)
  const time = Timestamp.fromDate(new Date());
  const [price, setPrice] = useState("")
  const [stripe50Modal, setStripe50Modal] = useState(false);
  const [status, setStatus] = useState("lifetime")
  const [inputCode, setInputCode] = useState("");
  const [promoCodeLoading, setPromoCodeLoading] = useState(false);
  const [data, setData] = useState({
    contactName: "",
    email: "",
    category: categoryName || "startup",
    country: "",
    payCode: "",
    paymentPending: true,
    letMeKnow: true,
    error: "",
    createdAt: time,
    loading: false,
    message: "",
    showCaptcha: false,
    verified: false,
    contactNameError: false,
    emailError: false,
    password: "",
    passwordError: false,
    countryError: false,
    countryComplete: false,
    how: "",
    userId: "",
  });
    const [screenshotUrl, setScreenshotUrl] = useState(""); //for bug report
    const [bugEmail, setBugEmail] = useState("");
    const [bugText, setBugText] = useState(null);
    const [bugError, setBugError] = useState(null);

    const [detectedCountry, setDetectedCountry] = useState("");
  let location = useLocation();
  const promo = location.state?.promo || "Used promo code.";
  const discount = location.state?.discount || 100;

  const [userLocation, setUserLocation] = useState("");
  

  //These are the REAL ONES
  const lifetimeInvestorPrice = "price_1R96GD00vN5ANT6HF33yeFXk";
  const lifetimeStartupPrice = "price_1QKfXl00vN5ANT6HACgtqS4x";
  const yearlyInvestorPrice = "price_1Qcnab00vN5ANT6HopDFlDDZ";
  const yearlyStartupPrice = "price_1R96E000vN5ANT6HnfzV0kZe";

  const lifetimeStartup20OFFPrice = "price_1REuNK00vN5ANT6HrX4CMOOJ";
  const yearlyStartup20OFFPrice = "price_1REufy00vN5ANT6HFdPsrsBB"

  // const lifetimeInvestorPrice = "price_1R9bM300vN5ANT6HsTIKRMZB";
  // const lifetimeStartupPrice = "price_1R9bLN00vN5ANT6HVMf6RUdg";
  // const yearlyInvestorPrice = "price_1R9bL400vN5ANT6H4lfJT71j";
  // const yearlyStartupPrice = "price_1R9bKf00vN5ANT6HHyNMnr5q";

  const howOptions = ["Word of mouth", "Newsletter", "Startup event or conference", "LinkedIn", "Google", "Facebook/Instagram"]

  const handleUploadBug = (e) => {
    return new Promise((resolve, reject) => {
      const selectedFile = e.target.files[0];

      const storageRef = ref(storage, `bugs/${selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      uploadTask.on(
        "state_changed",
        null, // Manejador de progreso (puedes dejarlo como `null` si no necesitas reportarlo)
        (error) => {
          // Manejador de error
          console.error("Upload failed:", error);
          reject(error);
        },
        async () => {
          // Manejador de éxito
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
          console.log("uploaded correctly");
          setScreenshotUrl(downloadURL);
        }
      );
    });
  };

  const handleBugText = (e) => {
    const value = e.target.value;
    setBugText(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const handleBugEmail = (e) => {
    const value = e.target.value;
    setBugEmail(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const validateFields = () => {
    if (!bugText || bugText.trim() === "") {
      setBugError("Please describe the bug.");
      return false;
    }
    if (!bugEmail || bugEmail.trim() === "") {
      setBugError("We need your email address.");
      return false;
    }
    return true;
  };

  const handleUploadAndSendEmail = async (file) => {
    try {
      if (!validateFields()) return;

      let uploadedUrl = screenshotUrl;
      if (file) {
        uploadedUrl = await handleUploadBug({ target: { files: [file] } });
      }

      console.log(`screenshotUrl ${uploadedUrl}`);
      sendBugEmails(bugEmail, "", bugText, "Landing page", uploadedUrl || "");
    } catch (error) {
      console.error("Error uploading file or sending email:", error);
    }
  };

  useEffect(() => {
    const fetchPromoCodes = async () => {
      const promoCodesCollection = collection(db, "promoCodes");
      const snapshot = await getDocs(promoCodesCollection, {
        fromCache: false,
      });
      const promoCodesList = snapshot.docs.map((doc) => doc.data().code);
      setPromoCodes(promoCodesList);
      //console.log('Promo Codes:', promoCodesList);
    };
    fetchPromoCodes();
  }, []);

  useEffect(() => {
    if (category==="startup"){
      setPrice(lifetimeStartupPrice) //default
    }
    if (category==="investor"){
      setPrice(lifetimeInvestorPrice) //default
    }
  }, [])

  const handleGoClick = async () => { //used to work for 2 things, now it's only for promo codes
    setPromoCodeLoading(true);
    const promoCode = promoCodes.find((code) => code === inputCode);
    if (promoCode) {
      const docRef = await addDoc(collection(db, "codeStats"), {
        code: inputCode,
        inputAt: Timestamp.fromDate(new Date()),
        used: false,
      });
      try {
        const q = query(
          collection(db, "promoCodes"),
          where("code", "==", inputCode)
        );
        const querySnapshot = await getDocs(q);
        const codeId = querySnapshot.docs[0].id;
        let codeRef = doc(db, "promoCodes", codeId);
        const docData = (await getDoc(codeRef)).data();
        setAcceptedCode(true)
        setData({...data, paymentPending: false})
      } catch (error) {
        console.log(error);
      }
    } else {
      setValidPopup(true);
    }
    setPromoCodeLoading(false);
  };

  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    if (promoId==="stripe"){
      if (!acceptedCode){
        setIsStripe(true)
        setData({
          ...data,
          payCode: generateRandomString(10),
        });
        return;
      }
    }
else{
  const checkCodeStats = async () => {
    try {
      setData({
        ...data,
        payCode: promo,
        category: categoryName,
        paymentPending: false,
      });
      const docRef = doc(db, "codeStats", promoId);

      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        //console.log("exists")
        if (docSnap.id === "vsqBZMXiHUCiNEYSYQsi") {
          setData({
            ...data,
            payCode: "QR",
            category: categoryName,
            paymentPending: false,
          });
        }
      } else {
        //console.log("doesnt exist")
        navigate("/");
      }
    } catch (error) {
      console.error("Error checking codeStats:", error);
    }
  };
  checkCodeStats();
}
}, [categoryName, promoId]);

  const sendErrorEmail = async () => {
    const functions = getFunctions();
    const sendEmailFn = httpsCallable(functions, "sendEmail");
    try {
      //console.log('send email' + JSON.stringify(currentUser))
      await sendEmailFn({
        templateId: 45,
        recipients: [
          {
            name: "Caro",
            email: "caro@prairi.com",
          },
        ],
        params: {
          DOCUID: email,
          FILE: "Invitation.js",
        },
      });

    } catch (error) {
      // Handle error
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const setPricingStatus = () => {
    if (status==="yearly"){
      setStatus("lifetime")
      if (category==="startup"){
        setPrice(lifetimeStartupPrice)
      }
      if (category==="investor"){
        setPrice(lifetimeInvestorPrice)
      }
    }
    if (status==="lifetime"){
      setStatus("yearly")
      if (category==="startup"){
        setPrice(yearlyStartupPrice)
      }
      if (category==="investor"){
        setPrice(yearlyInvestorPrice)
      }
    }
  }
  

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    
    // Clear error messages when user starts typing
    if (data.error) {
      setData(prevData => ({ ...prevData, error: "" }));
    }
    
    // Clear usedEmail flag when email is changed
    if (name === "email" && usedEmail) {
      setUsedEmail(false);
    }
  };
  const updateFieldValidity = (bool, fieldName) => {
    if (bool) {
      setData({ ...data, [`${fieldName}Error`]: true });
    } else {
      setData({ ...data, [`${fieldName}Error`]: false });
    }
  };



  const isValid = (fieldName) => {
    switch (fieldName) {
      case "contactName":
        updateFieldValidity(validator.isEmpty(data.contactName), fieldName);
        break;
      case "url":
        updateFieldValidity(!validator.isURL(data.url), fieldName);
        break;
      case "email":
        updateFieldValidity(!validator.isEmail(data.email), fieldName);
        break;
      case "linkedin":
        updateFieldValidity(!validator.isURL(data.linkedin), fieldName);
        break;
      case "password":
        updateFieldValidity(
          data.password.length < 8 ||
          !/\d/.test(data.password) ||
          !/[!@#$%^&*(),.?":{}|<>]/.test(data.password),
          fieldName
        );
        break;
      default:
        break;
    }
  };

  const [touchedFields, setTouchedFields] = useState({
    email: false,
    contactName: false,
    country: false,
  });

  const handleBlur = (field) => {
    setTouchedFields(prev => ({ ...prev, [field]: true }));
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          "https://ipinfo.io/json?token=00b36ccb7a5f35"
        );
        const countryCode = response.data.country.toLowerCase();
        const detectedCountry =
          countriesData.find(
            (country) => country.code.toLowerCase() === countryCode
          )?.name || ""; // Si no encuentra el país, se quedará con una cadena vacía

        setDetectedCountry(detectedCountry);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
  }, []);

  // Add new useEffect to set country when detectedCountry is available
  useEffect(() => {
    if (detectedCountry && !data.country) {
      setData(prevData => ({
        ...prevData,
        country: detectedCountry,
        countryComplete: true,
        countryError: false
      }));
    }
  }, [detectedCountry]);

  const isFinallyValid = () => {
    let dataCopy = { ...data };
  
    // Validar username
    if (validator.isEmpty(data.contactName)) {
      dataCopy = {
        ...dataCopy,
        contactNameError: true,
        error: "Fill all the required fields",
      };
    } else {
      dataCopy = {
        ...dataCopy,
        contactNameError: false,
        error: ""
      };
    }
  
    // Validar email
    if (!validator.isEmail(data.email)) {
      dataCopy = {
        ...dataCopy,
        emailError: true,
        error: "Fill all the required fields.",
      };
    } else {
      dataCopy = {
        ...dataCopy,
        error: "",
        emailError: false,
      };
    }
  
    // Validar password
    if (data.password.length < 8 ||
        !/\d/.test(data.password) ||
        !/[!@#$%^&*(),.?":{}|<>]/.test(data.password)
    ) {
      dataCopy = {
        ...dataCopy,
        passwordError: true,
        error: "Password must be at least 8 characters long and include at least one number and one special character",
      };
    } else {
      dataCopy = {
        ...dataCopy,
        passwordError: false,
        error: ""
      };
    }

    // Validar country
    if (validator.isEmpty(data.country)) {
      dataCopy = {
        ...dataCopy,
        countryError: true,
        countryComplete: false,
        error: "Please select your country",
      };
    } else {
      dataCopy = {
        ...dataCopy,
        countryError: false,
        countryComplete: true,
        error: ""
      };
    }
  
    setData({ ...dataCopy });
  
    const {
      contactNameError,
      emailError,
      countryError,
    } = dataCopy;
  
    return !(contactNameError || emailError|| countryError);
  };
  
  const handleSubmit = async () => {
    setData({
      ...data,
      error: "",
      showCaptcha: false,
      loading: true,
      message: "Creating your account...",
      submitted: true
    });
  
    try {
      if (!data.email) {
        throw new Error("Email address is required.");
      }
  
      // Llamar a la Cloud Function que crea el usuario y devuelve el token personalizado
      const response = await axios.post(
        "https://us-central1-prairi-prod-fe3a4.cloudfunctions.net/createNewUser", 
        {
          email: data.email.toLowerCase(),
          contactName: data.contactName,
          category: data.category,
          letMeKnow: data.letMeKnow,
          country: data.country,
          how: data.how,
          payCode: data.payCode,
          paymentPending: data.paymentPending,
          status: data.status,
        }
      );

      // Store the userId from the response and set verified to true
      if (response.data.success) {
        setData({
          ...data,
          userId: response.data.userId,
          verified: true,
          loading: false,
          message: "Account created successfully!",
          showCaptcha: false,
        });
      } else {
        // Handle case where the request was successful but the operation failed
        throw new Error(response.data.error || "Failed to create account. Please try again.");
      }

    } catch (error) {
      console.error("Error registering user:", error);
      
      let errorMessage = "An unexpected error occurred. Please try again.";
      
      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        const serverError = error.response.data?.error || error.response.data?.message;
        
        switch (status) {
          case 400:
            if (serverError && serverError.toLowerCase().includes('email')) {
              errorMessage = "This email address is already registered. Please use a different email or try logging in.";
              setUsedEmail(true);
            } else {
              errorMessage = serverError || "Invalid request. Please check your information and try again.";
            }
            break;
          case 409:
            errorMessage = "This email address is already registered. Please use a different email or try logging in.";
            setUsedEmail(true);
            break;
          case 422:
            errorMessage = serverError || "Please check your information and try again.";
            break;
          case 429:
            errorMessage = "Too many requests. Please wait a moment and try again.";
            break;
          case 500:
            errorMessage = "Server error. Please try again later or contact support if the problem persists.";
            sendErrorEmail();
            break;
          default:
            errorMessage = serverError || `Server error (${status}). Please try again.`;
            break;
        }
      } else if (error.request) {
        // Network error - no response received
        errorMessage = "Network error. Please check your internet connection and try again.";
      } else if (error.message) {
        // Other errors (like validation errors)
        errorMessage = error.message;
      }
      
      setData({
        ...data,
        error: errorMessage,
        loading: false,
        message: "",
      });
    }
  };
  

  const verificationHandler = (value) => {
    if (value) {
      setData({ ...data, showCaptcha: false });
      handleSubmit();
    }
  };

  const showCaptchaHandler = (e) => {
    e.preventDefault();
    setSubmitted(true)
   // console.log(JSON.stringify(data))
    const valid = isFinallyValid()
    if (valid) {
      setData({ ...data, showCaptcha: true });
    }
  };
  const {
    contactName,
    email,
    showCaptcha,
    verified,
    error,
    payCode,
    letMeKnow,
    message,
    paymentPending,
    createdAt,
    contactNameError,
    emailError,
    category,
    userId,
  } = data;

  let renderedComponent = "";

  if (category==="startup") {
    renderedComponent = (
      <div
        style={{
          marginTop: navBarHeight -62,
          marginBottom: navBarHeight,
          backgroundColor: "#1e1e1d ",
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.75)",
          borderRadius: "30px",
          maxWidth: "500px",
          minWidth: "460px",
        }}
      >
                    <div className="flex flex-col justify-center items-center">
              <NotValid click={() => setValidPopup(false)} open={validPopup} />
            </div>
              <BugTab
                email={bugEmail}
                setEmail={handleBugEmail}
                setText={handleBugText}
                submit={(file) => handleUploadAndSendEmail(file)}
                error={bugError}
                handleFileChange={handleUploadBug}
              />

<h3 className=" pt-5 text-center text-base font-bold text-white">
          Join PRAIRI as a Startup
        </h3>
        
          <div className="flex justify-center items-start pt-2">
            <div className="flex justify-between w-[80%]  py-2  items-center">
          <div className="text-[#f2f2f2] px-2 mb-4 flex flex-col">
            <div className={`text-xl font-bold ${acceptedCode && "line-through decoration-red-500"}`}>{status==="lifetime"? "$149":"$99"}</div>
            <div className="text-md">{status==="lifetime"? "one-time payment":"billed yearly"}</div>
          </div>
          {!acceptedCode ? (
            <div className="flex pt-4 p-2 items-start ">
              <div className="text-[#b5b5b5] pb-4 text-xs">Promo code?</div>
              <div className="flex flex-col items-end">
                <input
                  type="text"
                  className="  rounded-md h-5 ml-2 text-black w-[90px] bg-customWhite"
                  value={inputCode}
                  onChange={(e) => setInputCode(e.target.value.toUpperCase())}
                ></input>
                <div className="flex items-center">
                  {promoCodeLoading && <AiOutlineLoading3Quarters className="animate-spin text-greenPrairi mr-2" size={16} />}
                  <input
                    type="button"
                    className={` cursor-pointer my-2 border-gray-500   border py-1 px-2 rounded-md text-[10px] ml-1  uppercase outline-none ${
                         "bg-greenPrairi text-[black]"
                    }`}
                    value="Apply"
                    disabled={inputCode === "" || promoCodeLoading}
                    onClick={() => handleGoClick()}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center pb-2 text-sm items-center">
              <div className="flex items-center"><MdCheckCircle color="#92d050"/>              <div className="text-greenPrairi px-2">Promo code accepted!</div></div>

              <div className="text-silverPrairi">Your cost is <span className="font-bold">$0</span></div>
            </div>
          )}

          </div>

          </div>
          {wrongCode && <div className="flex justify-center  py-2 text-sm items-center">
          <div><MdCheckCircle color="#92d050"/></div>
          <div className="text-redPrairi px-2">Sorry, invalid promo code.</div>
          </div>}
        <form className="" onSubmit={showCaptchaHandler}>
          <div className="flex items-center justify-between mb-7 px-9">
            <div className="w-full">
              <div className="mt-5">
                <label htmlFor="contactName">Your Name</label>
                <input
                  className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none "
                  type="text"
                  name="contactName"
                  id="contactName"
                  placeholder="First and Last (contact name for investors)"
                  value={contactName}
                  onChange={handleChange}
                  onBlur={() => isValid("contactName")}
                ></input>
                        {contactNameError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Name is required
                  </div>
                )}
              </div>
              <div className="mt-5">
                <label htmlFor="email">
                  Company Email 
                </label>
                <input
                  className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={handleChange}
                  onBlur={() => isValid("email")}
                ></input>
                {emailError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Invalid Email
                  </div>
                )}

              </div>
              <div className="mt-5">
                <label htmlFor="country">
                  Location of company (country where you are officially headquartered)
                </label>
                <div className="flex items-center">
                  <select
                    className={`${
                      data.countryError ? "border-red-500" : "border-blackish"
                    } mt-2.5 w-full rounded border-2 p-2.5 text-black outline-none`}
                    value={data.country}
                    onChange={handleChange}
                    name="country"
                    id="country"
                    onBlur={() => handleBlur("country")}
                  >
                    <option value="">Select a country</option>
                    {countriesData.map((country) => (
                      <option key={country.code} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>

                </div>
                {data.countryError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Please select your country
                  </div>
                )}
              </div>
              <div className="mt-5">
                <label htmlFor="how">How did you hear about us?</label>
                <select
                  className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
                  type="text"
                  name="how"
                  id="how"
                  placeholder="How did you hear about us?"
                  value={data.how}
                  onChange={handleChange}
                >
                  <option value="" disabled selected style={{ color: '#9ca3af' }}>Select one...</option>
                  {howOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="flex justify-center w-[90%] mx-auto  items-center mt-5">
                <label htmlFor="letMeKnow" className="flex items-start cursor-pointer select-none relative">
                  <input
                    type="checkbox"
                    id="letMeKnow"
                    name="letMeKnow"
                    checked={letMeKnow}
                    onChange={e => setData({ ...data, letMeKnow: e.target.checked })}
                    className="hidden"
                  />
                  <span
                    className="flex items-center justify-center mr-4"
                    style={{
                      width: 34,
                      height: 22,
                      border: '1px solid #f2f2f2',
                      borderRadius: 3,
                      transition: 'background 0.2s',
                      overflow: 'visible',
                      zIndex: 1,
                    }}
                  >
                    {letMeKnow && (
                      <img
                        src={GreenTick}
                        alt="checked"
                        style={{
                          width: 30,
                          height: 'auto',
                          position: 'absolute',
                          left: '4%',
                          top: '18%',
                          transform: 'translate(-50%, -50%)',
                          zIndex: 50,
                          pointerEvents: 'none',
                        }}
                      />
                    )}
                  </span>
                  <span className="text-white">Let me know about the latest investor and startup news, funding tips, exclusive events, webinars, and more.</span>
                </label>
              </div> */}
            </div>
          </div>
          <div className=" text-center ">
            {showCaptcha && (
              <ReCAPTCHA
                className="flex justify-center pt-4 mb-5"
                sitekey="6LfiNNgjAAAAAC_oJEe3mXyKzDky3ncopW49_R3p"
                onChange={verificationHandler}
              />
            )}
            <input
              type="submit"
              className=" 
              uppercase bg-green-600 
              cursor-pointer px-2 h-8 
              border-gray-500 border           
              text-sm   mb-4 outline-none  "
              value={acceptedCode?"JOIN PRAIRI":"COMPLETE YOUR PAYMENT"}
              style={{
                backgroundColor: "#92d050",
                borderRadius: "5px",
                color: "black",
              }}
            />
            {!acceptedCode && <div className="flex justify-center w-full">
              <img src={Cards} className="w-1/2  my-2" alt="cards"/>
            </div>}
          </div>
        </form>{" "}
        {error && (
          <div className="flex justify-center items-center my-2">
            <p className="text-center text-red-500 text-sm px-4">
              {error}
            </p>
          </div>
        )}
        {message && (
          <div className="flex justify-center items-center my-2">
            <AiOutlineLoading3Quarters className="animate-spin text-greenPrairi mr-2" size={20} />
            <span className="text-greenPrairi">Creating your account...</span>
          </div>
        )}


      </div>
    );
  }
  if (category === "investor") {
    renderedComponent = (
      <div
        style={{
          backgroundColor: "#1e1e1d ",
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.75)",
          borderRadius: "30px",
          marginTop: navBarHeight - 62,
          maxWidth: "500px",
          marginBottom: navBarHeight,
        }}
      >
        <div className="flex flex-col justify-center items-center">
          <NotValid click={() => setValidPopup(false)} open={validPopup} />
        </div>
        <BugTab
          email={bugEmail}
          setEmail={handleBugEmail}
          setText={handleBugText}
          submit={(file) => handleUploadAndSendEmail(file)}
          error={bugError}
          handleFileChange={handleUploadBug}
        />

        <h3 className="pt-2 text-center text-base font-bold text-white">
          Join PRAIRI as an investor
        </h3>
        {
          <div className="flex justify-center items-start pt-2">
            <div className="flex justify-between w-[80%]  py-2  items-center">
              <div className="text-[#f2f2f2] px-2 mb-4 flex flex-col">
                <div className={`text-xl font-bold ${acceptedCode && "line-through decoration-red-500"}`}>{status==="lifetime"? "$1200":"$900"}</div>
                <div className="text-md">{status==="lifetime"? "one-time payment":"billed yearly"}</div>
              </div>
              {!acceptedCode ? (
                <div className="flex pt-4 p-2 items-start ">
                  <div className="text-[#b5b5b5] pb-4 text-xs">Promo code?</div>
                  <div className="flex flex-col items-end">
                    <input
                      type="text"
                      className="  rounded-md h-5 ml-2 text-black w-[90px] bg-customWhite"
                      value={inputCode}
                      onChange={(e) => setInputCode(e.target.value.toUpperCase())}
                    ></input>
                    <div className="flex items-center">
                      {promoCodeLoading && <AiOutlineLoading3Quarters className="animate-spin text-greenPrairi mr-2" size={16} />}
                      <input
                        type="button"
                        className={` cursor-pointer my-2 border-gray-500   border py-1 px-2 rounded-md text-[10px] ml-1  uppercase outline-none ${
                             "bg-greenPrairi text-[black]"
                        }`}
                        value="Apply"
                        disabled={inputCode === "" || promoCodeLoading}
                        onClick={() => handleGoClick()}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col justify-center pb-2 text-sm items-center">
                  <div className="flex items-center"><MdCheckCircle color="#92d050"/>              <div className="text-greenPrairi px-2">Promo code accepted!</div></div>

                  <div className="text-silverPrairi">Your cost is <span className="font-bold">$0</span></div>
                </div>
              )}

            </div>

          </div>
        }
        {wrongCode && <div className="flex justify-center  py-2 text-sm items-center">
          <div><MdCheckCircle color="#92d050"/></div>
          <div className="text-redPrairi px-2">Sorry, invalid promo code.</div>
        </div>}
        <form className="" onSubmit={showCaptchaHandler}>
          <div className="flex items-center justify-between mb-7 px-9">
            <div className="w-full">
              <div className="mt-5">
                <label htmlFor="contactName">Your Name</label>
                <input
                  className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
                  type="text"
                  name="contactName"
                  id="contactName"
                  placeholder="First and Last (contact name for investors)"
                  value={contactName}
                  onChange={handleChange}
                  onBlur={() => isValid("contactName")}
                />
                {contactNameError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Name is required
                  </div>
                )}
              </div>
              <div className="mt-5">
                <label htmlFor="email">
                  Company Email 
                </label>
                <input
                  className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={handleChange}
                  onBlur={() => isValid("email")}
                />
                {emailError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Invalid Email
                  </div>
                )}
                {usedEmail && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    This email is already registered. Please use a different email or try logging in.
                  </div>
                )}
              </div>
              <div className="mt-5">
                <label htmlFor="country">
                  Location of investor/company (country where you are officially headquartered)
                </label>
                <div className="flex items-center">
                  <select
                    className={`${
                      data.countryError ? "border-red-500" : "border-blackish"
                    } mt-2.5 w-10/12 md:w-11/12 rounded border-2 p-2.5 text-black outline-none`}
                    value={data.country}
                    onChange={handleChange}
                    name="country"
                    id="country"
                    onBlur={() => handleBlur("country")}
                  >
                    <option value="">Select a country</option>
                    {countriesData.map((country) => (
                      <option key={country.code} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>

                </div>
                {data.countryError && (
                  <div className="w-full text-sm text-red-500 mt-2">
                    Please select your country
                  </div>
                )}
              </div>


            </div>
          </div>
          <div className="text-center">
            {showCaptcha && (
              <ReCAPTCHA
                className="flex justify-center pt-4 mb-5"
                sitekey="6LfiNNgjAAAAAC_oJEe3mXyKzDky3ncopW49_R3p"
                onChange={verificationHandler}
              />
            )}
            <input
              type="submit"
              className="uppercase bg-green-600 cursor-pointer px-2 h-8 border-gray-500 border text-sm mb-4 outline-none"
              value={acceptedCode?"JOIN PRAIRI":"COMPLETE YOUR PAYMENT"}
              style={{
                backgroundColor: "#92d050",
                borderRadius: "5px",
                color: "black",
              }}
            />
            <div className="flex justify-center w-full">
              <img src={Cards} className="w-1/2  my-2" alt="cards"/>
            </div>
          </div>
        </form>
        {error && (
          <div className="flex justify-center items-center my-2">
            <p className="text-center text-red-500 text-sm px-4">
              {error}
            </p>
          </div>
        )}
        {message && <p className="my-2 ml-2 text-greenPrairi">{message}</p>}
      </div>
    );
  }
    if (verified && category === "investor" ) {
    if (acceptedCode) {
      if (!usedEmail  && discount === 100) {
        setTimeout(() => {
          navigate(`/createpassword/${userId}`)
        }, 2000)
      }
    } else {
      const handleStripeRedirect = async () => {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          mode: `${status==="lifetime"?"payment":"subscription"}`,
          lineItems: [{ price: price, quantity: 1 }],
          successUrl: `https://prairi.com/success/${userId}`, //this id will be the id for preUsers, let's remember that
          cancelUrl: `https://prairi.com/cancel/${userId}`,
        });
        
        if (error) {
          console.error('Stripe redirect error:', error);
        }
      };
      handleStripeRedirect();
    }
  }
  
  if (verified && category === "startup" ) {
    if (acceptedCode) {
      if (!usedEmail  && discount === 100) {
        setTimeout(() => {
          navigate(`/createpassword/${userId}`)
        }, 2000)
      }
    } else {
      const handleStripeRedirect = async () => {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          mode: `${status==="lifetime"?"payment":"subscription"}`,
          lineItems: [{ price: price, quantity: 1 }],
          successUrl: `https://prairi.com/success/${userId}`, //this id will be the id for preUsers, let's remember that
          cancelUrl: `https://prairi.com/cancel/${userId}`,
        });
        
        if (error) {
          console.error('Stripe redirect error:', error);
        }
      };
      handleStripeRedirect();
    }
  }
  
  // Add useEffect to handle navigation when userId is available
  useEffect(() => {
    if (verified && category !== "investor" && acceptedCode && userId && !usedEmail && discount === 100) {
      console.log("Navigating to password page with userId:", userId);
      setTimeout(() => {
        navigate(`/createpassword/${userId}`)
      }, 2000)
    }
  }, [verified, category, acceptedCode, userId, usedEmail, discount, navigate]);

  if (!verified) {
  }

  // Add useEffect to update state when route changes
  useEffect(() => {
    setData(prevData => ({
      ...prevData,
      category: categoryName || "startup"
    }));
    setSubmitted(false);
    setAcceptedCode(false);
    setInputCode("");
  }, [categoryName]);

  // Auto-clear error messages after 10 seconds
  useEffect(() => {
    if (data.error) {
      const timer = setTimeout(() => {
        setData(prevData => ({ ...prevData, error: "" }));
      }, 10000);
      
      return () => clearTimeout(timer);
    }
  }, [data.error]);

  return (
    <section className="w-full flex justify-center items-center bg-[#262626]">
      <div
        style={{
          marginTop: navBarHeight,
          marginBottom: navBarHeight + 470,
          height: "100%",
          width: "100%",
        }}
        className={`
      min-w-[366px]
      mx-auto  
      text-xs  rounded-lg
      text-white flex justify-center items-center ${isMobile&& "flex-col"}`}
      >
              <BugTab
                email={bugEmail}
                setEmail={handleBugEmail}
                setText={handleBugText}
                submit={(file) => handleUploadAndSendEmail(file)}
                error={bugError}
                handleFileChange={handleUploadBug}
              />
         <div className="pt-0 pb-14 flex flex-col justify-center items-center">
         <Pricing setStatus={setPricingStatus} status={status} investor={category==="investor"} notUs={userLocation!=="us"}/>
          </div>     

        {renderedComponent}
        <Modal open={errorPopup} border="silver">
          <div className="flex justify-center flex-col">
            <div className="flex justify-center mb-2">
              <img
                className="flex justify-center w-[15%]"
                alt="crying icon"
                src={CryingIcon}
              ></img>
            </div>
            <div className="flex justify-center font-bold my-2">
              We're sorry, but this isn't working.{" "}
            </div>
            <div className="flex  mb-2">
              It's not you it's us… it's our fast growth and frequent site
              updates.{" "}
            </div>
            <div className="flex  mb-2">
              Please try again later. Thank you for your patience!{" "}
            </div>
            <div className="flex justify-center">
              <PrairiButton
                border="green"
                label="OK"
                size="sm"
                rounded="soft"
                click={() => navigate("/")}
              />

            </div>
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default Invitation;